import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { SANDBOX_DEMO_ENABLED } from '@/shared/config';

import { ensureDemoPatients } from '../api/ensureDemoPatients.js';
import { writeDemoRoster } from './rosterCache.js';

export function useEnsureDemoPatients(): void {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationKey: ['sandbox-demo', 'ensure'],
    mutationFn: ensureDemoPatients,
    // The only shot this session gets; the server call is idempotent.
    retry: 3,
    onSuccess: (roster) => {
      writeDemoRoster(queryClient, roster);
    },
    meta: { toastOnError: false, sentryOnError: false },
  });
  const { mutate } = mutation;

  useEffect(() => {
    if (!SANDBOX_DEMO_ENABLED) {
      return;
    }
    mutate();
  }, [mutate]);
}
